import store from '@/store/index.js';
import link from "@/scripts/host.js";
import handleError from '@/scripts/handleError.js'


export default {
  name: "RemindPassword",
  props: ["close"],
  data() {
    return {
      login: ""
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },
    remind() {
      this.axios({
        method: "post",
        url: `${link.hostLink}Account/ForgotPassword`,
        data: { userName: this.login }
      })
        .then(() => {
          store.dispatch('setGenericModalText', 'Wysłano e-mail z linkiem do resetu hasła.');

       store.dispatch('setModalType', 'genericModal');
        })
        .catch(error => {
          
          handleError(error.response);
        });
    }
  },

  mounted() {}
};
